import React, { Component }         from 'react';
import { GuaranteeLetterCards }     from './GuaranteeLetterCards';
import { GuaranteeLetterOptions }   from './GuaranteeLetterOptions';
import { GuaranteeLetterRequest }   from './GuaranteeLetterRequest';
import AuthService                  from 'services/auth.service';
import GuaranteeLetterService       from 'services/guarantee-letter.service';
import queryString                  from 'query-string';
import moment                       from 'moment';

const location = AuthService.getPracticeLocation();

class GuaranteeLetter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page:         this.props.params.page || 1,
      total_pages:  1,
      per:          10,
      search:       this.props.params.search,
      search_send:  this.props.params.search,
      nric:         this.props.params.nric,
      nric_send:    this.props.params.nric,
      start_date:   this.props.params.start_date,
      end_date:     this.props.params.end_date,
      doctype:      this.props.params.doctype,
      select_color: !this.props.params.doctype ? 'grayed' : '',
      more_actions: false,
      items: [],
      stats: {
        stats_opened: 0,
        stats_issued: 0,
        stats_rejected: 0,
        stats_pending: 0,
        stats_expired: 0
      }
    };
  }

  reloadList() {
    const parameters = queryString.stringify({
      page: this.state.page,
      per: this.state.per,
      practice_location_id: location?.id,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      search: this.state.search_send,
      nric: this.state.nric_send,
      doctype: this.state.doctype
    });

    GuaranteeLetterService.list(parameters).then(
      (data) => {
        const meta = data.metadata;

        const stats = {
          stats_opened: meta.opened,
          stats_issued: meta.issued,
          stats_rejected: meta.rejected,
          stats_pending: meta.pending,
          stats_expired: meta.expired
        }

        this.setState({
          page: meta.current_page,
          total_pages: meta.total_pages,
          stats: stats,
          items: data.guarantee_letters
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    this.reloadList();
  }

  handlePage(previous) {
    var pageNumber = this.state.page;
    const totalPages = this.state.total_pages;

    if (previous) {
      pageNumber = pageNumber === 1 ? 1 : pageNumber - 1;
    } else {
      pageNumber = pageNumber === totalPages ? totalPages : pageNumber + 1;
    }

    this.setState({ page: pageNumber }, this.reloadList)
  }

  updateDateRange(start_date, end_date) {
    let parseStartDate;
    let parseEndDate;

    if (start_date === 'skip') {
      parseStartDate = this.state.start_date;
    } else {
      parseStartDate = start_date ? moment(start_date).format('DD/MM/YYYY') : '';
    }

    if (end_date === 'skip') {
      parseEndDate = this.state.end_date;
    } else {
      parseEndDate = end_date ? moment(end_date).format('DD/MM/YYYY') : '';
    }

    this.setState({
      page: 1,
      start_date: parseStartDate,
      end_date: parseEndDate,
    }, this.reloadList);
  }

  handleSelectChange(value) {
    this.setState({
      doctype: value,
      select_color: !value ? 'grayed' : ''
    });
  }

  applySearchFilters() {
    this.setState({
      page: 1,
      search_send: this.state.search,
      nric_send: this.state.nric.replace(/-/g, ''),
      doctype: this.state.doctype
    }, this.reloadList);
  }

  pageClick(target) {
    const newState = (target.id !== 'request-gl-more-btn' && target.id !== 'request-gl-arrow-down-icon') ? false : true;
    if (this.state.more_actions !== newState) this.setState({ more_actions: newState });
  }

  render() {
    return (
      <div id="main-content-target"  onClick={(e) => this.pageClick(e.target) }>
        <GuaranteeLetterRequest handleReload={() => this.reloadList() } moreActions={ this.state.more_actions } />
        <h1 className="text-danger">Guarantee Letter</h1>

        <div>
          <GuaranteeLetterOptions
            page={ this.state.page }
            total_pages={ this.state.total_pages }
            stats={ this.state.stats }
            prevPage={() => this.handlePage(true) }
            nextPage={() => this.handlePage(false) }
            startDate={ this.state.start_date }
            endDate={ this.state.end_date }
            changeDate={(start_date, end_date) => this.updateDateRange(start_date, end_date) }
            changeFilters={(status, amount) => this.updateFilters(status, amount) }
          />

          <div id="guarantee-letter-filter-bar" className="d-sm-flex align-items-center justify-content-between p-4 mt-8 bg-faintred">
            <div className="input-holder">
              <input
                type="text"
                placeholder="Patient Name"
                className="form-control rounded-pill"
                value={ this.state.search }
                onChange={(e) => this.setState({ search: e.target.value }) }
              />
            </div>

            <div className="input-holder">
              <input
                type="text"
                placeholder="Patient IC/Passport No."
                className="form-control rounded-pill"
                value={ this.state.nric }
                onChange={(e) => this.setState({ nric: e.target.value }) }
              />
            </div>

            <div className="input-holder">
              <select id="doctype-field" className={ "form-control rounded-pill px-4 " + this.state.select_color } value={ this.state.doctype } onChange={(e) => this.handleSelectChange(e.target.value) }>
                <option value="">Document Type</option>
                <option value="outpatient_specialist">Outpatient Specialist</option>
                <option value="admission_form">Admission Form</option>
                <option value="discharge_form">Discharge Form</option>
              </select>
            </div>

            <button className="btn btn-danger rounded-pill py-3 w-em-24" onClick={() => this.applySearchFilters() }>Search Now</button>
          </div>

          <GuaranteeLetterCards items={ this.state.items } handleReload={() => this.reloadList() } />
        </div>
      </div>
    )
  }
}

export default GuaranteeLetter;